import type { ReactNode } from "react";
import { PARTNER_PORTAL } from "../../shared/config";
import { PortalMark } from "./Logo";
import { PortalModeToggle } from "./PortalModeToggle";

/**
 * The split-screen auth chrome shared by login + invited signup: a brand scene on
 * the left, the form card on the right. The left scene explains how the program
 * works in three honest steps. It shows NO fabricated payout numbers: real
 * earnings appear inside the app once there is real activity.
 */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="auth">
      <div className="scene-aura" aria-hidden="true" />
      <div className="scene-grid" aria-hidden="true" />

      <div className="auth-scene">
        <div className="brand">
          <PortalMark />
          Partner <span className="l">Portal</span>
        </div>

        <div className="hero-mid">
          <div className="hero-hl">
            Get paid to <span className="u">share</span>.
          </div>
          <p className="hero-sub">
            You share a link. When someone you send becomes a customer, you earn. Tracked to the
            cent, paid on your terms.
          </p>
        </div>

        <ol className="auth-steps" aria-label="How it works">
          <li>
            <span className="as-n">1</span>
            <div>
              <b>Share your link</b>
              <span>Post your referral link or coupon anywhere you have an audience.</span>
            </div>
          </li>
          <li>
            <span className="as-n">2</span>
            <div>
              <b>They become a customer</b>
              <span>Last click wins. Every sale is attributed back to you automatically.</span>
            </div>
          </li>
          <li>
            <span className="as-n">3</span>
            <div>
              <b>You get paid</b>
              <span>Rewards clear their hold, then the owner pays you directly.</span>
            </div>
          </li>
        </ol>
      </div>

      <div className="auth-panel">
        <div className="auth-topright">
          <PortalModeToggle />
        </div>
        {children}
      </div>
    </div>
  );
}

/** The "powered by Flashadz" line used under each auth card. */
export function PoweredBy() {
  return <div className="powered">{PARTNER_PORTAL.poweredBy}</div>;
}
